import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import StatusActive from "../../../components/constants/StatusActive";
import axios from "axios";
import Layout from "../../../components/common/Layout";
import Alerts from "../../layout/Alerts";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import checkTime from "../../../components/constants/CheckTime"
import { addAuditLog } from "../../../components/AuditLog"

const nameColumns = [
  {
    cell: (row) => (
      <div>
        <Link to={'/quotations/view/1'} target="_blank" >
          <button className="btn btn-sm btn-primary"><i className="fa fa-eye"></i> View</button>
        </Link>
      </div>
    ),
    ignoreRowClick: false,
    allowOverflow: true,
    button: true,
    show: 1
  },
  {
    name: "Quotation No.",
    selector: "col1",
    sortable: true,
    wrap: true
  },
  {
    name: "Customer Name",
    selector: "col2",
    sortable: true,
    wrap: true
  },
  {
    name: "Status",
    selector: "col3",
    width: "100px",
    sortable: true,
    wrap: true
  }
];

const Name = props => {
  const userId =
  JSON.parse(localStorage.getItem("user")) === null
    ? null
    : JSON.parse(localStorage.getItem("user"))[0].Id;

  const pagePermission =
      JSON.parse(localStorage.getItem("permission")) === null
      ? {IsCreate: false,
        IsDelete: false,
        IsUpdate: false,
        IsView: false}
      : JSON.parse(localStorage.getItem("permission")).filter(c => parseInt(c.MenuId) === 5)[0];

  const [isHidden, setIsHidden] = useState({
    names : 0,
    address : 1,
    case: 1
  })
  const [nameData, setnameData] = useState([]);
  const [showManageColumns, setShowManageColumns] = useState(false);
  
  const selectDefaultDdl = [
    { value: 0, label: "Start with"},
    { value: 1, label: "End with"},
    { value: 2, label: "Contain"},
    { value: 3, label: "Does not contain"},
    { value: 4, label: "Equal to"},
    { value: 5, label: "Does not equal to"}
  ];

  useEffect(() => {
    checkTime();
    document.addEventListener("mousedown",  (e) => { checkTime(); });
    submitsearch();
    
    //eslint-disable-next-line
  }, []);

  const submitsearch = () => {
    setnameData([{col1:"Q0001",col2:"CUS001",col3:"Active"}
          ,{col1:"Q0002",col2:"CUS002",col3:"Active"}
          ,{col1:"Q0003",col2:"CUS003",col3:"Active"}
          ,{col1:"Q0004",col2:"CUS004",col3:"Active"}
          ,{col1:"Q0005",col2:"CUS005",col3:"Active"}]);
  };

  return (
    <Layout activeLinkTo="/quotations" menuId="20">
      <div className="container-fluid" style={{ minHeight: 500 }}>
      <Alerts />
        <div className="card border-secondary"> {/* Name */}
          <h5 
            className="card-header text-white" 
            style={{backgroundColor:"rgb(80, 79, 125)", cursor:"pointer"}}
            onClick={ () => setIsHidden({ ...isHidden, name: !isHidden.name})}>
            <i className={"fa fa-" + (isHidden.name ? "plus" : "minus") + "-square-o"} />  Quotation
          </h5>
          <div className="card-body" hidden={isHidden.name}>
            <div className="row">
              <div className="col-lg-6">
                <label className="title control-label">
                  Quotation No.
                </label>
                <div className="input-group">
                  <div className="form-control col-lg-4" style={{padding:0, borderStyle:"hidden"}}>
                  <Select 
                    options={selectDefaultDdl}
                  />
                  </div>
                  <input
                    type="search"
                    className="form-control col-lg-8"
                    name="nameCodeText"
                    onKeyUp={ e => e.keyCode === 13 ? submitsearch(): null }
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <label className="title control-label">
                  Customer Name
                </label>
                <div className="input-group">
                  <div className="form-control col-lg-4" style={{padding:0, borderStyle:"hidden"}}>
                  <Select 
                    options={selectDefaultDdl}
                  />
                  </div>
                  <input
                    type="search"
                    className="form-control col-lg-8"
                    name="nameText"
                    onKeyUp={ e => e.keyCode === 13 ? submitsearch(): null }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        { 
          // ----------------------------------button---------------------------------------
        }
        <div className="card-body text-right">
        <button
          type="button"
          className="btn btn-secondary mr-2"
        >
          <i className="fa fa-refresh" /> Clear
        </button>
          <button
              type="button"
              className="btn btn-primary"
              onClick={submitsearch}
            >
            <i className="fa fa-search" /> Search
          </button>
        </div>
        
        <hr style={{borderTop:"1px solid rgb(173, 173, 173)"}}/>
        {
          // ----------------------------------Result---------------------------------------
        }
        <div className="card border-secondary">
          <h5 className="card-header text-white bg-primary">Data</h5>
          <div className="card-body">
            <div className="row">
              <div className="table-responsive">
                <Link to="/quotations/add" hidden={!pagePermission.IsCreate}>
                  <button type="button" className="btn btn-success">
                    <FontAwesomeIcon icon={faPlus} /> Add
                  </button>
                </Link>
                <a href="#down" id="top" style={{position:"absolute", right:"0px", padding:"63px 17px 0 0", zIndex:"1"}}>
                  <i className="fa fa-arrow-down" style={{color:"#c8c8c8"}}/>
                </a>
                <DataTable
                  noHeader={true}
                  pagination={true}
                  paginationPerPage={50}
                  paginationRowsPerPageOptions={[10, 20, 50, 100]}
                  columns={nameColumns}
                  data={nameData}
                />
                <a href="#top" id="down" style={{position:"absolute", right:"0px", padding:"0 17px"}}>
                  <i className="fa fa-arrow-up" style={{color:"#c8c8c8"}}/>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal Manage Columns*/}
      <Modal
        size="sm"
        dialogClassName="columnsManageCustom"
        show={showManageColumns}
        onHide={() => {
          setShowManageColumns(false);
        }}
        centered
      >
        <Modal.Header closeButton className="replaceCloseBtn">
          <Modal.Title><i className="fa fa-columns" /> Manage Columns</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container">
            <div className="row">
              
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {/* Modal Manage columns*/}
    </Layout>
  );
};

export default Name;
